export function flatTree(root, out) {
    if (out === void 0) { out = []; }
    root.forEach(function (point) {
        out.push(point);
        if (point.children && point.children.length) {
            flatTree(point.children, out);
        }
    });
    return out;
}
export function buildTree(root, list, key, parentKey, parentPath, createor) {
    return root.map(function (item, index) {
        var nodePath = parentPath.slice();
        nodePath.push(index);
        var node = createor(item, nodePath);
        var children = list.filter(function (child) { return child[parentKey] && child[parentKey] === item[key]; });
        node.children = buildTree(children, list, key, parentKey, nodePath, createor);
        return node;
    });
}
export function tranverseTree(tree, callback) {
    tree.forEach(function (item) {
        callback(item);
        if (item.children) {
            tranverseTree(item.children, callback);
        }
    });
}
